
import { Request } from './Request';

export interface IGetAllowedClassesParams {
    federatableOnly: string;
}

export interface IGetAllowedClassesResult {
    allowedClasses: string[];
}

export class GetAllowedClassesRequest extends Request<IGetAllowedClassesParams, IGetAllowedClassesResult> {
    constructor(params: IGetAllowedClassesParams) {
        super('getAllowedClasses', params);
    }
}
